export const LIVE_ESCAPE_ADMIN_GET = 'LIVE_ESCAPE_ADMIN_GET';
export const LIVE_ESCAPE_ADMIN_UPDATE = 'LIVE_ESCAPE_ADMIN_UPDATE';
export const ON_LIVE_ESCAPE_ADMIN_UPDATED = 'ON_LIVE_ESCAPE_ADMIN_UPDATED';